// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-modern." + {"83":"a274f4822ccdb27c9090","658":"8d0b53e7962e6cacab33"}[chunkId] + ".js";
};